import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QrCode2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"qr_code_2"}/>
}
